export function initInitialState($form, h) {
  const { hide } = h

  function apply() {
    // reservista (controlado pelo modulo reservista.js)
    hide($form.find(".params_movimentacoes_pessoal_certificado_reservista"))
    hide($form.find(".params_codigo_reservista"))

    // vale transporte condicionais
    hide($form.find(".params_numero_cartao_vale_transporte"))
    hide($form.find(".params_esta_desvinculado_da_empresa_anterior"))
    hide($form.find(".params_entrar_em_contato_antiga_empresa"))
    hide($form.find(".params_valor_ticket_alimentacao"))
    hide($form.find(".params_valor_ticket_refeicao"))

    hide($form.find(".params_tipo_desconto_contracheque"))
    hide($form.find(".params_desconto_em_contracheque"))
    hide($form.find(".possui_cartao_bilhete_unico"))

    // limpa textos auxiliares
    $form.find(".doc-text").remove()
  }

  apply()
  return { destroy() { } }
}
